import { render, staticRenderFns } from "./DocDivRegSearch.vue?vue&type=template&id=b11752aa&scoped=true"
import script from "./DocDivRegSearch.vue?vue&type=script&lang=js"
export * from "./DocDivRegSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11752aa",
  null
  
)

export default component.exports